/**
 * Prospectos: un punto en el mapa y poco más.
 *
 * Es lo que se captura caminando la calle, cuando alguien todavía no dio datos
 * para ser cliente. Un prospecto es una chincheta con una nota: aquí hay un
 * negocio, ya pasé, esto fue lo que me dijeron.
 *
 * **No vive con los clientes**, y esa separación es deliberada. La maestra de
 * clientes exige nombre, teléfono con consentimiento y una cuenta con la que se
 * puede facturar; meter ahí registros sin nombre la llenaría de fantasmas que
 * después nadie sabe si son cuentas de verdad. Un prospecto nace suelto y se
 * convierte en cliente el día que hay con qué, y la conversión deja escrito de
 * cuál prospecto salió.
 *
 * Lo mínimo que necesita para existir es la coordenada. Todo lo demás —el
 * nombre del sitio, la nota, la foto— es opcional a propósito: si capturar
 * exigiera llenar un formulario, nadie capturaría mientras camina.
 */
export const ESTADOS_PROSPECTO = [
    { valor: 'pendiente', texto: 'Por visitar', tono: 'pendiente', nota: 'Marcado, sin hablar todavía.' },
    { valor: 'interesado', texto: 'Interesado', tono: 'pendiente', nota: 'Hay con quién seguir. Volver.' },
    { valor: 'por_cerrar', texto: 'Por cerrar', tono: 'pendiente', nota: 'Pidió precios o muestra. Falta el último empujón.' },
    { valor: 'descartado', texto: 'Descartado', tono: 'gris', nota: 'No es cliente. Queda para no volver a pasar.' },
    { valor: 'convertido', texto: 'Ya es cliente', tono: 'ok', nota: 'Pasó a la maestra de clientes.' },
];
export function textoEstadoProspecto(e) {
    return ESTADOS_PROSPECTO.find((x) => x.valor === e)?.texto ?? e;
}
export function tonoEstadoProspecto(e) {
    return ESTADOS_PROSPECTO.find((x) => x.valor === e)?.tono ?? 'gris';
}
/** Los que todavía representan una oportunidad. Lo que se pinta en el mapa. */
export function estaVivo(e) {
    return e === 'pendiente' || e === 'interesado' || e === 'por_cerrar';
}
/** Cómo se llama en pantalla uno que no tiene nombre todavía. */
export function tituloProspecto(p) {
    return p.nombre?.trim() || p.direccion?.trim() || 'Sin nombre';
}
/** P-0042 */
export function numeroProspecto(consecutivo) {
    return `P-${String(consecutivo).padStart(4, '0')}`;
}
/**
 * Lo que se pinta en la chincheta y en la lista.
 *
 * Si no alcanzó a tomar consecutivo —se marcó sin señal— cae a un código corto
 * del identificador. No es bonito y no es secuencial, pero es único y está en
 * los dos lados, que es para lo único que sirve esto.
 */
export function codigoProspecto(p, id) {
    return p.numero || `#${id.slice(-4).toUpperCase()}`;
}
